import { render, staticRenderFns } from "./OrdersSummary.vue?vue&type=template&id=b644cb84"
import script from "./OrdersSummary.vue?vue&type=script&lang=js"
export * from "./OrdersSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports